import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';
export const UserDetailsHeader = (): ReactElement => {
  const { t } = useTranslator();
  return <HeaderWithDescription header={t('account')} />;
};
